import React from 'react';
import { motion } from 'framer-motion';
import { LineChart, ChevronRight } from 'lucide-react';
import Button from '../ui/Button';

const TradingTools = () => {
  return (
    <div className="grid lg:grid-cols-2 gap-12 items-center mb-24">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="relative order-2 lg:order-1"
      >
        <div className="relative rounded-2xl overflow-hidden shadow-2xl">
          <img
            src="https://trustedsignals.com/wp-content/uploads/2024/12/Screenshot-2024-12-13-202518.png"
            alt="HankoX Trading Tools"
            className="w-full h-auto rounded-2xl transform hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/20 to-transparent" />
        </div>
      </motion.div>

      <div className="order-1 lg:order-2">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="inline-flex items-center bg-blue-500/10 text-blue-400 px-4 py-2 rounded-full text-sm font-medium backdrop-blur-sm border border-blue-500/20 mb-6"
        >
          <LineChart className="h-4 w-4 mr-2" />
          Professional Trading Tools
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="text-3xl md:text-4xl font-bold text-white mb-6"
        >
          Advanced Tools for{' '}
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-400 via-blue-500 to-purple-600">
            Smart Trading
          </span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="text-gray-300 text-lg mb-8"
        >
          Access professional-grade trading tools designed to enhance your trading performance. From advanced charting to automated trading systems, we provide everything you need for successful trading.
        </motion.p>

        <Button
          icon={ChevronRight}
          className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800"
        >
          Explore Tools
        </Button>
      </div>
    </div>
  );
}

export default TradingTools;